export { default as default } from './Quadrat';
